declare global {
  interface Window {
    dataLayer: Array<DataLayerEvent>;
  }
}

interface DataLayerEvent {
  event: string;
  user_type: string;
  method?: string;
  action: string;
}

window.dataLayer = window.dataLayer || [];

export const pushDataLayerEvent = (dataLayerEvent: DataLayerEvent) => {
  window.dataLayer.push(dataLayerEvent);
};

export const API_REGION_VERSION_MAP: { [key: string]: string } = {
  enUS: "v7",
  zhTW: "v2",
  koKR: "v2",
  jaJP: "v2",
  deDE: "v1",
  deCH: "v1",
  deAT: "v1",
  frCH: "v1",
  itIT: "v1",
  nlNL: "v1",
  daDK: "v1",
  nnNO: "v1",
  svSE: "v1",
};
